"use strict";'use strict';

var chunkXOB2L3XG_js = require('./chunk-XOB2L3XG.js');
require('./chunk-FGILNJMU.js');



module.exports = chunkXOB2L3XG_js.Global_default;
